import DelaysManager from "../../pages/delays/delays-manager";
import DelaysPareto from "../../pages/delays/delays-pareto";
import DelaysReport from "../../pages/delays/delays-report";
import { RouteConfig } from "./types";

// Define Delay routes with flat structure
export const delayRoutes: RouteConfig[] = [
  {
    path: "/delays-manager",
    element: <DelaysManager />,
  },
  {
    path: "/delays-manager/:shiftId",
    element: <DelaysManager />,
  },
  {
    path: "/delays-report",
    element: <DelaysReport />,
  },
  {
    path: "/delays-report/:shiftId",
    element: <DelaysReport />,
  },
  {
    path: "/delays-pareto",
    element: <DelaysPareto />,
  },
];
